export const registrationMessages = {
  "zh_hans": {
    "auth.phoneRegister": "手机号注册",
    "auth.emailRegister": "邮箱注册",
    "auth.usernameRegister": "用户名注册",
    "auth.username": "用户名",
    "auth.usernamePlaceholder": "请输入用户名",
    "auth.confirmPassword": "确认密码",
    "auth.confirmPasswordPlaceholder": "请再次输入密码",
    "auth.passwordPlaceholder": "请输入密码",
    "auth.phonePlaceholder": "请输入手机号",
    "auth.phoneCountryCode": "手机号国码",
    "auth.email": "邮箱",
    "auth.emailCode": "邮箱验证码",
    "auth.emailPlaceholder": "请输入邮箱",
    "auth.codePlaceholder": "请输入验证码",
    "auth.smsCodePlaceholder": "请输入短信验证码",
    "auth.sendCode": "发送验证码",
    "auth.sending": "发送中…",
    "auth.showCaptcha": "显示验证码",
    "auth.refreshCaptcha": "点击更换验证码",
    "auth.captchaAlt": "6位小写字母与数字验证码",
    "auth.registering": "注册中…",
    "auth.loginPassword": "登录密码",
    "auth.loginPasswordPlaceholder": "请输入登录密码",
    "auth.saveAndEnter": "保存并进入",
    "auth.localCodePlaceholder": "请输入短信验证码",
    "registration.loading": "正在读取注册方式…",
    "registration.closed": "当前未开放新用户注册",
    "registration.backMethods": "返回选择注册方式",
    "registration.passwordHint": "至少 6 位字符",
    "registration.identity": "手机号 / 邮箱 / 用户名",
    "registration.identityPlaceholder": "请输入手机号、邮箱或用户名",
    "registration.usernameRules": "4–32个字符，以文字或数字开头；允许常见文字、数字及 _ - .，符号不能连续。",
    "registration.usernameInvalid": "用户名格式不符合规则，请检查下方说明。",
    "registration.phoneInvalid": "请输入正确的手机号和国家区号。",
    "registration.emailInvalid": "请输入正确的邮箱地址。",
    "registration.invalidCode": "验证码错误或已过期，请重新获取。",
    "registration.passwordInvalid": "密码需为 6–128 位字符。",
    "registration.methodClosed": "此注册方式已关闭，请选择其他方式。",
    "registration.modeChanged": "验证码模式已变更，请重新打开注册页面。",
    "registration.tooMany": "请求次数过多，请一小时后重试。",
    "registration.retryLater": "请求较多，请稍后重试；发送验证码需间隔 60 秒。",
    "registration.failed": "注册服务暂时不可用，请稍后重试。",
    "registration.createFailed": "注册失败，账号可能已存在，请尝试登录或稍后重试。",
    "registration.success": "注册成功，请使用刚设置的密码登录。",
    "registration.codeSent": "验证码已发送，请在 5 分钟内填写。",
    "registration.invalidRequest": "请求格式错误，请重新打开注册页面。",
    "registration.expired": "注册状态已失效，请重新注册。",
    "registration.passwordIncomplete": "请填写完整密码。",
    "registration.passwordMismatch": "两次输入的密码不一致。",
    "registration.passwordSaveFailed": "密码设置失败，请重试。",
    "auth.iconAlt": "{name} 图标"
  },
  "zh_hant": {
    "auth.phoneRegister": "手機號註冊",
    "auth.emailRegister": "電子郵件註冊",
    "auth.usernameRegister": "使用者名稱註冊",
    "auth.username": "使用者名稱",
    "auth.usernamePlaceholder": "請輸入使用者名稱",
    "auth.confirmPassword": "確認密碼",
    "auth.confirmPasswordPlaceholder": "請再次輸入密碼",
    "auth.passwordPlaceholder": "請輸入密碼",
    "auth.phonePlaceholder": "請輸入手機號碼",
    "auth.phoneCountryCode": "手機號國碼",
    "auth.email": "電子郵件",
    "auth.emailCode": "電子郵件驗證碼",
    "auth.emailPlaceholder": "請輸入電子郵件",
    "auth.codePlaceholder": "請輸入驗證碼",
    "auth.smsCodePlaceholder": "請輸入簡訊驗證碼",
    "auth.sendCode": "傳送驗證碼",
    "auth.sending": "傳送中…",
    "auth.showCaptcha": "顯示驗證碼",
    "auth.refreshCaptcha": "點擊更換驗證碼",
    "auth.captchaAlt": "6位小寫字母與數字驗證碼",
    "auth.registering": "註冊中…",
    "auth.loginPassword": "登入密碼",
    "auth.loginPasswordPlaceholder": "請輸入登入密碼",
    "auth.saveAndEnter": "儲存並進入",
    "auth.localCodePlaceholder": "請輸入簡訊驗證碼",
    "registration.loading": "正在讀取註冊方式…",
    "registration.closed": "目前未開放新使用者註冊",
    "registration.backMethods": "返回選擇註冊方式",
    "registration.passwordHint": "至少 6 個字元",
    "registration.identity": "手機號 / 電子郵件 / 使用者名稱",
    "registration.identityPlaceholder": "請輸入手機號、電子郵件或使用者名稱",
    "registration.usernameRules": "4–32個字元，以文字或數字開頭；允許常見文字、數字及 _ - .，符號不能連續。",
    "registration.usernameInvalid": "使用者名稱格式不符合規則，請檢查下方說明。",
    "registration.phoneInvalid": "請輸入正確的手機號及國碼。",
    "registration.emailInvalid": "請輸入正確的電子郵件地址。",
    "registration.invalidCode": "驗證碼錯誤或已過期，請重新取得。",
    "registration.passwordInvalid": "密碼需為 6–128 個字元。",
    "registration.methodClosed": "此註冊方式已關閉，請選擇其他方式。",
    "registration.modeChanged": "驗證碼模式已變更，請重新開啟註冊頁面。",
    "registration.tooMany": "請求次數過多，請一小時後重試。",
    "registration.retryLater": "請求較多，請稍後重試；傳送驗證碼需間隔 60 秒。",
    "registration.failed": "註冊服務暫時無法使用，請稍後重試。",
    "registration.createFailed": "註冊失敗，帳號可能已存在，請嘗試登入或稍後重試。",
    "registration.success": "註冊成功，請使用剛設定的密碼登入。",
    "registration.codeSent": "驗證碼已傳送，請在 5 分鐘內填寫。",
    "registration.invalidRequest": "請求格式錯誤，請重新開啟註冊頁面。",
    "registration.expired": "註冊狀態已失效，請重新註冊。",
    "registration.passwordIncomplete": "請填寫完整密碼。",
    "registration.passwordMismatch": "兩次輸入的密碼不一致。",
    "registration.passwordSaveFailed": "密碼設定失敗，請重試。",
    "auth.iconAlt": "{name} 圖示"
  },
  "en": {
    "auth.phoneRegister": "Register by phone",
    "auth.emailRegister": "Register by email",
    "auth.usernameRegister": "Register by username",
    "auth.username": "Username",
    "auth.usernamePlaceholder": "Enter username",
    "auth.confirmPassword": "Confirm password",
    "auth.confirmPasswordPlaceholder": "Enter password again",
    "auth.passwordPlaceholder": "Enter password",
    "auth.phonePlaceholder": "Enter phone number",
    "auth.phoneCountryCode": "Country calling code",
    "auth.email": "Email",
    "auth.emailCode": "Email verification code",
    "auth.emailPlaceholder": "Enter email address",
    "auth.codePlaceholder": "Enter verification code",
    "auth.smsCodePlaceholder": "Enter SMS code",
    "auth.sendCode": "Send code",
    "auth.sending": "Sending…",
    "auth.showCaptcha": "Show verification image",
    "auth.refreshCaptcha": "Click to refresh code",
    "auth.captchaAlt": "6-character lowercase letter and digit code",
    "auth.registering": "Registering…",
    "auth.loginPassword": "Login password",
    "auth.loginPasswordPlaceholder": "Enter login password",
    "auth.saveAndEnter": "Save and enter",
    "auth.localCodePlaceholder": "Enter SMS verification code",
    "registration.loading": "Loading registration options…",
    "registration.closed": "New user registration is currently closed.",
    "registration.backMethods": "Choose another registration method",
    "registration.passwordHint": "At least 6 characters",
    "registration.identity": "Phone / Email / Username",
    "registration.identityPlaceholder": "Enter phone, email or username",
    "registration.usernameRules": "4–32 characters, starting with a letter or number. Use common letters, digits and _ - . without consecutive symbols.",
    "registration.usernameInvalid": "The username does not meet the rules below.",
    "registration.phoneInvalid": "Enter a valid phone number and country code.",
    "registration.emailInvalid": "Enter a valid email address.",
    "registration.invalidCode": "The code is incorrect or expired. Get a new code.",
    "registration.passwordInvalid": "Password must contain 6–128 characters.",
    "registration.methodClosed": "This registration method is closed. Choose another method.",
    "registration.modeChanged": "Verification mode changed. Reopen registration.",
    "registration.tooMany": "Too many requests. Try again in one hour.",
    "registration.retryLater": "Please try again shortly. Wait 60 seconds between code requests.",
    "registration.failed": "Registration service is unavailable. Please try again later.",
    "registration.createFailed": "Registration failed. The account may already exist. Try signing in or try again later.",
    "registration.success": "Registration complete. Sign in with your new password.",
    "registration.codeSent": "Code sent. Enter it within 5 minutes.",
    "registration.invalidRequest": "Invalid request. Reopen the registration page.",
    "registration.expired": "Registration expired. Please start again.",
    "registration.passwordIncomplete": "Enter both password fields.",
    "registration.passwordMismatch": "The passwords do not match.",
    "registration.passwordSaveFailed": "Could not save the password. Try again.",
    "auth.iconAlt": "{name} icon"
  },
  "km": {
    "auth.phoneRegister": "ចុះឈ្មោះតាមលេខទូរស័ព្ទ",
    "auth.emailRegister": "ចុះឈ្មោះតាមអ៊ីមែល",
    "auth.usernameRegister": "ចុះឈ្មោះតាមឈ្មោះអ្នកប្រើ",
    "auth.username": "ឈ្មោះអ្នកប្រើ",
    "auth.usernamePlaceholder": "បញ្ចូលឈ្មោះអ្នកប្រើ",
    "auth.confirmPassword": "បញ្ជាក់ពាក្យសម្ងាត់",
    "auth.confirmPasswordPlaceholder": "បញ្ចូលពាក្យសម្ងាត់ម្តងទៀត",
    "auth.passwordPlaceholder": "បញ្ចូលពាក្យសម្ងាត់",
    "auth.phonePlaceholder": "បញ្ចូលលេខទូរស័ព្ទ",
    "auth.phoneCountryCode": "លេខកូដប្រទេស",
    "auth.email": "អ៊ីមែល",
    "auth.emailCode": "លេខកូដផ្ទៀងផ្ទាត់អ៊ីមែល",
    "auth.emailPlaceholder": "បញ្ចូលអាសយដ្ឋានអ៊ីមែល",
    "auth.codePlaceholder": "បញ្ចូលលេខកូដផ្ទៀងផ្ទាត់",
    "auth.smsCodePlaceholder": "បញ្ចូលលេខកូដ SMS",
    "auth.sendCode": "ផ្ញើលេខកូដ",
    "auth.sending": "កំពុងផ្ញើ…",
    "auth.showCaptcha": "បង្ហាញរូបភាពផ្ទៀងផ្ទាត់",
    "auth.refreshCaptcha": "ចុចដើម្បីប្ដូរលេខកូដ",
    "auth.captchaAlt": "លេខកូដ 6 តួអក្សរ លាយអក្សរតូចនិងលេខ",
    "auth.registering": "កំពុងចុះឈ្មោះ…",
    "auth.loginPassword": "ពាក្យសម្ងាត់ចូលប្រើ",
    "auth.loginPasswordPlaceholder": "បញ្ចូលពាក្យសម្ងាត់ចូលប្រើ",
    "auth.saveAndEnter": "រក្សាទុកនិងចូល",
    "auth.localCodePlaceholder": "បញ្ចូលលេខកូដ SMS",
    "registration.loading": "កំពុងផ្ទុកវិធីចុះឈ្មោះ…",
    "registration.closed": "ការចុះឈ្មោះអ្នកប្រើថ្មីត្រូវបានបិទ។",
    "registration.backMethods": "ជ្រើសរើសវិធីចុះឈ្មោះផ្សេង",
    "registration.passwordHint": "យ៉ាងតិច 6 តួអក្សរ",
    "registration.identity": "លេខទូរស័ព្ទ / អ៊ីមែល / ឈ្មោះអ្នកប្រើ",
    "registration.identityPlaceholder": "បញ្ចូលលេខទូរស័ព្ទ អ៊ីមែល ឬឈ្មោះអ្នកប្រើ",
    "registration.usernameRules": "4–32 តួអក្សរ ចាប់ផ្ដើមដោយអក្សរឬលេខ។ ប្រើអក្សរធម្មតា លេខ និង _ - . ដោយមិនដាក់សញ្ញាជាប់គ្នា។",
    "registration.usernameInvalid": "ឈ្មោះអ្នកប្រើមិនត្រឹមត្រូវ សូមពិនិត្យលក្ខខណ្ឌខាងក្រោម។",
    "registration.phoneInvalid": "បញ្ចូលលេខទូរស័ព្ទនិងលេខកូដប្រទេសត្រឹមត្រូវ។",
    "registration.emailInvalid": "បញ្ចូលអាសយដ្ឋានអ៊ីមែលត្រឹមត្រូវ។",
    "registration.invalidCode": "លេខកូដមិនត្រឹមត្រូវឬផុតកំណត់ សូមយកលេខកូដថ្មី។",
    "registration.passwordInvalid": "ពាក្យសម្ងាត់ត្រូវមាន 6–128 តួអក្សរ។",
    "registration.methodClosed": "វិធីចុះឈ្មោះនេះត្រូវបានបិទ សូមជ្រើសវិធីផ្សេង។",
    "registration.modeChanged": "របៀបផ្ទៀងផ្ទាត់បានផ្លាស់ប្ដូរ សូមបើកទំព័រចុះឈ្មោះឡើងវិញ។",
    "registration.tooMany": "សំណើច្រើនពេក សូមព្យាយាមម្តងទៀតក្រោយមួយម៉ោង។",
    "registration.retryLater": "សូមព្យាយាមម្តងទៀតបន្តិចក្រោយ។ ចាំ 60 វិនាទីរវាងការស្នើលេខកូដ។",
    "registration.failed": "សេវាចុះឈ្មោះមិនអាចប្រើបាន សូមព្យាយាមម្តងទៀតពេលក្រោយ។",
    "registration.createFailed": "ចុះឈ្មោះមិនបាន គណនីអាចមានរួចហើយ។ សូមចូលប្រើឬព្យាយាមពេលក្រោយ។",
    "registration.success": "ចុះឈ្មោះជោគជ័យ សូមចូលដោយពាក្យសម្ងាត់ថ្មី។",
    "registration.codeSent": "បានផ្ញើលេខកូដ សូមបញ្ចូលក្នុងរយៈពេល 5 នាទី។",
    "registration.invalidRequest": "សំណើមិនត្រឹមត្រូវ សូមបើកទំព័រចុះឈ្មោះឡើងវិញ។",
    "registration.expired": "ការចុះឈ្មោះផុតកំណត់ សូមចាប់ផ្ដើមឡើងវិញ។",
    "registration.passwordIncomplete": "សូមបំពេញពាក្យសម្ងាត់ទាំងពីរ។",
    "registration.passwordMismatch": "ពាក្យសម្ងាត់ទាំងពីរមិនដូចគ្នា។",
    "registration.passwordSaveFailed": "មិនអាចរក្សាទុកពាក្យសម្ងាត់ សូមព្យាយាមម្ដងទៀត។",
    "auth.iconAlt": "រូបតំណាង {name}"
  },
  "lo": {
    "auth.phoneRegister": "ລົງທະບຽນດ້ວຍເບີໂທ",
    "auth.emailRegister": "ລົງທະບຽນດ້ວຍອີເມວ",
    "auth.usernameRegister": "ລົງທະບຽນດ້ວຍຊື່ຜູ້ໃຊ້",
    "auth.username": "ຊື່ຜູ້ໃຊ້",
    "auth.usernamePlaceholder": "ປ້ອນຊື່ຜູ້ໃຊ້",
    "auth.confirmPassword": "ຢືນຢັນລະຫັດຜ່ານ",
    "auth.confirmPasswordPlaceholder": "ປ້ອນລະຫັດຜ່ານອີກຄັ້ງ",
    "auth.passwordPlaceholder": "ປ້ອນລະຫັດຜ່ານ",
    "auth.phonePlaceholder": "ປ້ອນເບີໂທ",
    "auth.phoneCountryCode": "ລະຫັດປະເທດ",
    "auth.email": "ອີເມວ",
    "auth.emailCode": "ລະຫັດຢືນຢັນອີເມວ",
    "auth.emailPlaceholder": "ປ້ອນທີ່ຢູ່ອີເມວ",
    "auth.codePlaceholder": "ປ້ອນລະຫັດຢືນຢັນ",
    "auth.smsCodePlaceholder": "ປ້ອນລະຫັດ SMS",
    "auth.sendCode": "ສົ່ງລະຫັດ",
    "auth.sending": "ກຳລັງສົ່ງ…",
    "auth.showCaptcha": "ສະແດງຮູບລະຫັດຢືນຢັນ",
    "auth.refreshCaptcha": "ກົດເພື່ອປ່ຽນລະຫັດ",
    "auth.captchaAlt": "ລະຫັດ 6 ຕົວ ປະສົມອັກສອນນ້ອຍແລະຕົວເລກ",
    "auth.registering": "ກຳລັງລົງທະບຽນ…",
    "auth.loginPassword": "ລະຫັດຜ່ານເຂົ້າລະບົບ",
    "auth.loginPasswordPlaceholder": "ປ້ອນລະຫັດຜ່ານເຂົ້າລະບົບ",
    "auth.saveAndEnter": "ບັນທຶກແລະເຂົ້າ",
    "auth.localCodePlaceholder": "ປ້ອນລະຫັດ SMS",
    "registration.loading": "ກຳລັງໂຫຼດວິທີລົງທະບຽນ…",
    "registration.closed": "ຕອນນີ້ຍັງບໍ່ເປີດລົງທະບຽນຜູ້ໃຊ້ໃໝ່.",
    "registration.backMethods": "ກັບໄປເລືອກວິທີລົງທະບຽນ",
    "registration.passwordHint": "ຢ່າງໜ້ອຍ 6 ຕົວອັກສອນ",
    "registration.identity": "ເບີໂທ / ອີເມວ / ຊື່ຜູ້ໃຊ້",
    "registration.identityPlaceholder": "ປ້ອນເບີໂທ ອີເມວ ຫຼືຊື່ຜູ້ໃຊ້",
    "registration.usernameRules": "4–32 ຕົວອັກສອນ ເລີ່ມດ້ວຍອັກສອນຫຼືຕົວເລກ. ໃຊ້ອັກສອນທົ່ວໄປ ຕົວເລກ ແລະ _ - . ໂດຍບໍ່ໃຊ້ສັນຍາລັກຕິດກັນ.",
    "registration.usernameInvalid": "ຊື່ຜູ້ໃຊ້ບໍ່ຖືກຕາມກົດ ກະລຸນາກວດຄຳແນະນຳຂ້າງລຸ່ມ.",
    "registration.phoneInvalid": "ປ້ອນເບີໂທແລະລະຫັດປະເທດໃຫ້ຖືກຕ້ອງ.",
    "registration.emailInvalid": "ປ້ອນທີ່ຢູ່ອີເມວໃຫ້ຖືກຕ້ອງ.",
    "registration.invalidCode": "ລະຫັດບໍ່ຖືກຫຼືໝົດອາຍຸ ກະລຸນາຂໍລະຫັດໃໝ່.",
    "registration.passwordInvalid": "ລະຫັດຜ່ານຕ້ອງມີ 6–128 ຕົວອັກສອນ.",
    "registration.methodClosed": "ວິທີລົງທະບຽນນີ້ຖືກປິດ ກະລຸນາເລືອກວິທີອື່ນ.",
    "registration.modeChanged": "ຮູບແບບຢືນຢັນປ່ຽນແລ້ວ ກະລຸນາເປີດໜ້າລົງທະບຽນໃໝ່.",
    "registration.tooMany": "ຮ້ອງຂໍຫຼາຍເກີນໄປ ກະລຸນາລອງໃໝ່ໃນອີກໜຶ່ງຊົ່ວໂມງ.",
    "registration.retryLater": "ກະລຸນາລອງໃໝ່ອີກບຶດ. ລໍຖ້າ 60 ວິນາທີກ່ອນຂໍລະຫັດອີກ.",
    "registration.failed": "ບໍລິການລົງທະບຽນຍັງໃຊ້ບໍ່ໄດ້ ກະລຸນາລອງໃໝ່ພາຍຫຼັງ.",
    "registration.createFailed": "ລົງທະບຽນບໍ່ສຳເລັດ ບັນຊີອາດມີແລ້ວ. ລອງເຂົ້າລະບົບຫຼືລອງໃໝ່ພາຍຫຼັງ.",
    "registration.success": "ລົງທະບຽນສຳເລັດ ກະລຸນາເຂົ້າດ້ວຍລະຫັດຜ່ານໃໝ່.",
    "registration.codeSent": "ສົ່ງລະຫັດແລ້ວ ກະລຸນາປ້ອນພາຍໃນ 5 ນາທີ.",
    "registration.invalidRequest": "ຄຳຮ້ອງຂໍບໍ່ຖືກ ກະລຸນາເປີດໜ້າລົງທະບຽນໃໝ່.",
    "registration.expired": "ສະຖານະລົງທະບຽນໝົດອາຍຸ ກະລຸນາເລີ່ມໃໝ່.",
    "registration.passwordIncomplete": "ກະລຸນາປ້ອນລະຫັດຜ່ານທັງສອງຊ່ອງ.",
    "registration.passwordMismatch": "ລະຫັດຜ່ານທັງສອງບໍ່ກົງກັນ.",
    "registration.passwordSaveFailed": "ບັນທຶກລະຫັດຜ່ານບໍ່ສຳເລັດ ກະລຸນາລອງໃໝ່.",
    "auth.iconAlt": "ໄອຄອນ {name}"
  },
  "th": {
    "auth.phoneRegister": "สมัครด้วยเบอร์โทร",
    "auth.emailRegister": "สมัครด้วยอีเมล",
    "auth.usernameRegister": "สมัครด้วยชื่อผู้ใช้",
    "auth.username": "ชื่อผู้ใช้",
    "auth.usernamePlaceholder": "กรอกชื่อผู้ใช้",
    "auth.confirmPassword": "ยืนยันรหัสผ่าน",
    "auth.confirmPasswordPlaceholder": "กรอกรหัสผ่านอีกครั้ง",
    "auth.passwordPlaceholder": "กรอกรหัสผ่าน",
    "auth.phonePlaceholder": "กรอกเบอร์โทร",
    "auth.phoneCountryCode": "รหัสประเทศ",
    "auth.email": "อีเมล",
    "auth.emailCode": "รหัสยืนยันอีเมล",
    "auth.emailPlaceholder": "กรอกอีเมล",
    "auth.codePlaceholder": "กรอกรหัสยืนยัน",
    "auth.smsCodePlaceholder": "กรอกรหัส SMS",
    "auth.sendCode": "ส่งรหัส",
    "auth.sending": "กำลังส่ง…",
    "auth.showCaptcha": "แสดงภาพรหัสยืนยัน",
    "auth.refreshCaptcha": "คลิกเพื่อเปลี่ยนรหัส",
    "auth.captchaAlt": "รหัส 6 ตัวผสมอักษรพิมพ์เล็กและตัวเลข",
    "auth.registering": "กำลังสมัคร…",
    "auth.loginPassword": "รหัสผ่านเข้าสู่ระบบ",
    "auth.loginPasswordPlaceholder": "กรอกรหัสผ่านเข้าสู่ระบบ",
    "auth.saveAndEnter": "บันทึกและเข้าใช้งาน",
    "auth.localCodePlaceholder": "กรอกรหัสยืนยัน SMS",
    "registration.loading": "กำลังโหลดวิธีสมัคร…",
    "registration.closed": "ขณะนี้ยังไม่เปิดรับสมัครผู้ใช้ใหม่",
    "registration.backMethods": "กลับไปเลือกวิธีสมัคร",
    "registration.passwordHint": "อย่างน้อย 6 ตัวอักษร",
    "registration.identity": "เบอร์โทร / อีเมล / ชื่อผู้ใช้",
    "registration.identityPlaceholder": "กรอกเบอร์โทร อีเมล หรือชื่อผู้ใช้",
    "registration.usernameRules": "4–32 ตัวอักษร เริ่มด้วยตัวอักษรหรือตัวเลข ใช้ตัวอักษรทั่วไป ตัวเลข และ _ - . โดยห้ามใช้สัญลักษณ์ติดกัน",
    "registration.usernameInvalid": "ชื่อผู้ใช้ไม่ตรงตามกฎ กรุณาตรวจสอบคำแนะนำด้านล่าง",
    "registration.phoneInvalid": "กรอกเบอร์โทรและรหัสประเทศให้ถูกต้อง",
    "registration.emailInvalid": "กรอกอีเมลให้ถูกต้อง",
    "registration.invalidCode": "รหัสไม่ถูกต้องหรือหมดอายุ กรุณาขอรหัสใหม่",
    "registration.passwordInvalid": "รหัสผ่านต้องมี 6–128 ตัวอักษร",
    "registration.methodClosed": "วิธีสมัครนี้ปิดแล้ว กรุณาเลือกวิธีอื่น",
    "registration.modeChanged": "รูปแบบการยืนยันเปลี่ยนแล้ว กรุณาเปิดหน้าสมัครใหม่",
    "registration.tooMany": "คำขอมากเกินไป กรุณาลองใหม่ในอีกหนึ่งชั่วโมง",
    "registration.retryLater": "กรุณาลองอีกครั้งภายหลัง เว้น 60 วินาทีระหว่างการขอรหัส",
    "registration.failed": "บริการสมัครยังใช้งานไม่ได้ กรุณาลองใหม่ภายหลัง",
    "registration.createFailed": "สมัครไม่สำเร็จ บัญชีอาจมีอยู่แล้ว ลองเข้าสู่ระบบหรือลองใหม่ภายหลัง",
    "registration.success": "สมัครสำเร็จ เข้าสู่ระบบด้วยรหัสผ่านที่ตั้งไว้",
    "registration.codeSent": "ส่งรหัสแล้ว กรุณากรอกภายใน 5 นาที",
    "registration.invalidRequest": "คำขอไม่ถูกต้อง กรุณาเปิดหน้าสมัครใหม่",
    "registration.expired": "สถานะการสมัครหมดอายุ กรุณาสมัครใหม่",
    "registration.passwordIncomplete": "กรอกรหัสผ่านทั้งสองช่อง",
    "registration.passwordMismatch": "รหัสผ่านทั้งสองไม่ตรงกัน",
    "registration.passwordSaveFailed": "ตั้งรหัสผ่านไม่สำเร็จ กรุณาลองใหม่",
    "auth.iconAlt": "ไอคอน {name}"
  },
  "vi": {
    "auth.phoneRegister": "Đăng ký bằng số điện thoại",
    "auth.emailRegister": "Đăng ký bằng email",
    "auth.usernameRegister": "Đăng ký bằng tên người dùng",
    "auth.username": "Tên người dùng",
    "auth.usernamePlaceholder": "Nhập tên người dùng",
    "auth.confirmPassword": "Xác nhận mật khẩu",
    "auth.confirmPasswordPlaceholder": "Nhập lại mật khẩu",
    "auth.passwordPlaceholder": "Nhập mật khẩu",
    "auth.phonePlaceholder": "Nhập số điện thoại",
    "auth.phoneCountryCode": "Mã điện thoại quốc gia",
    "auth.email": "Email",
    "auth.emailCode": "Mã xác minh email",
    "auth.emailPlaceholder": "Nhập địa chỉ email",
    "auth.codePlaceholder": "Nhập mã xác minh",
    "auth.smsCodePlaceholder": "Nhập mã SMS",
    "auth.sendCode": "Gửi mã",
    "auth.sending": "Đang gửi…",
    "auth.showCaptcha": "Hiện ảnh xác minh",
    "auth.refreshCaptcha": "Nhấn để đổi mã",
    "auth.captchaAlt": "Mã 6 ký tự gồm chữ thường và số",
    "auth.registering": "Đang đăng ký…",
    "auth.loginPassword": "Mật khẩu đăng nhập",
    "auth.loginPasswordPlaceholder": "Nhập mật khẩu đăng nhập",
    "auth.saveAndEnter": "Lưu và vào",
    "auth.localCodePlaceholder": "Nhập mã xác minh SMS",
    "registration.loading": "Đang tải cách đăng ký…",
    "registration.closed": "Hiện chưa mở đăng ký người dùng mới.",
    "registration.backMethods": "Quay lại chọn cách đăng ký",
    "registration.passwordHint": "Ít nhất 6 ký tự",
    "registration.identity": "Số điện thoại / Email / Tên người dùng",
    "registration.identityPlaceholder": "Nhập số điện thoại, email hoặc tên người dùng",
    "registration.usernameRules": "4–32 ký tự, bắt đầu bằng chữ hoặc số. Dùng chữ thông thường, số và _ - .; không dùng ký hiệu liên tiếp.",
    "registration.usernameInvalid": "Tên người dùng không đúng quy tắc bên dưới.",
    "registration.phoneInvalid": "Nhập số điện thoại và mã quốc gia hợp lệ.",
    "registration.emailInvalid": "Nhập địa chỉ email hợp lệ.",
    "registration.invalidCode": "Mã không đúng hoặc đã hết hạn. Hãy lấy mã mới.",
    "registration.passwordInvalid": "Mật khẩu phải có 6–128 ký tự.",
    "registration.methodClosed": "Cách đăng ký này đã đóng. Hãy chọn cách khác.",
    "registration.modeChanged": "Cách xác minh đã thay đổi. Hãy mở lại trang đăng ký.",
    "registration.tooMany": "Quá nhiều yêu cầu. Hãy thử lại sau một giờ.",
    "registration.retryLater": "Vui lòng thử lại sau. Đợi 60 giây giữa các lần yêu cầu mã.",
    "registration.failed": "Dịch vụ đăng ký chưa khả dụng. Vui lòng thử lại sau.",
    "registration.createFailed": "Đăng ký thất bại. Tài khoản có thể đã tồn tại. Hãy đăng nhập hoặc thử lại sau.",
    "registration.success": "Đăng ký thành công. Đăng nhập bằng mật khẩu vừa đặt.",
    "registration.codeSent": "Đã gửi mã. Nhập mã trong vòng 5 phút.",
    "registration.invalidRequest": "Yêu cầu không hợp lệ. Hãy mở lại trang đăng ký.",
    "registration.expired": "Phiên đăng ký đã hết hạn. Hãy bắt đầu lại.",
    "registration.passwordIncomplete": "Điền cả hai ô mật khẩu.",
    "registration.passwordMismatch": "Hai mật khẩu không khớp.",
    "registration.passwordSaveFailed": "Không thể lưu mật khẩu. Hãy thử lại.",
    "auth.iconAlt": "Biểu tượng {name}"
  }
};
